import React from 'react';
import PropTypes from 'prop-types';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';

class AccountMenu extends React.PureComponent {
  static propTypes = {
    inverted: PropTypes.bool,
    currentOrg: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    organizations: PropTypes.arrayOf(PropTypes.object),
    pathname: PropTypes.string,
    userEmail: PropTypes.string.isRequired,
    userName: PropTypes.string,
  };

  static defaultProps = {
    organizations: [],
  };

  state = {
    nextOrgId: undefined,
  };

  onAccountSwitch = (nextOrgId) => {
    if (nextOrgId) {
      this.setState({ nextOrgId }, () => {
        this.form.submit();
      });
    }
  };

  render() {
    const {
      currentOrg,
      inverted,
      isAdmin,
      organizations,
      pathname,
      userEmail,
      userName,
    } = this.props;

    return (
      <React.Fragment>
        <CommonChrome.AccountDropdown
          email={userEmail}
          hasMultipleOrgs={organizations.length > 1}
          inverted={inverted}
          organization={currentOrg}
          userName={userName}
        >
          {organizations.length > 1 && (
            <form
              ref={(ref) => (this.form = ref)}
              method="POST"
              action="/session/set_account"
            >
              <CommonChrome.NavMenuHeading>
                My Organizations
              </CommonChrome.NavMenuHeading>
              {organizations.map((organization, index) => {
                return (
                  <CommonChrome.AccountMenuItem
                    key={index}
                    href={`/session/set_account?account_id=${organization.id}`}
                    isActive={currentOrg.id === organization.id}
                    organization={organization}
                    onAccountSwitch={this.onAccountSwitch}
                  />
                );
              })}
              <CommonChrome.NavMenuDivider />
              <input
                type="hidden"
                name="return_to"
                value={pathname}
              />
              <input
                type="hidden"
                name="account_id"
                value={this.state.nextOrgId}
              />
            </form>
          )}
          <CommonChrome.NavMenuItem href='/account/referral'>
            Refer Friends
          </CommonChrome.NavMenuItem>
          <CommonChrome.NavMenuDivider />
          {
            isAdmin &&
            <React.Fragment>
              <CommonChrome.NavMenuItem href='/admin/dashboard'>
                Admin
              </CommonChrome.NavMenuItem>
              <CommonChrome.NavMenuDivider />
            </React.Fragment>
          }
          <CommonChrome.NavMenuItem href='/logout'>
            Log Out
          </CommonChrome.NavMenuItem>
        </CommonChrome.AccountDropdown>
      </React.Fragment>
    );
  }
}

export default AccountMenu;
